import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

export default function OrderTable({ prodList, maxHeight, prodReturn, total: totalParam, pickedTotal: pickedTotalParam }) {
  const total = prodReturn ? totalParam : prodList?.reduce((acc, curr) => acc + curr?.qty, 0);
  const currTotal = prodReturn ? pickedTotalParam : prodList?.reduce((acc, curr) => acc + (curr?.pickedQty || 0), 0);

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        maxHeight: maxHeight ? maxHeight : 350,
        height: "100%",
        border: "1px solid #c4c4c4",
      }}
    >
      <Table
        stickyHeader
        sx={{ minWidth: 300 }}
        size="small"
      >
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                fontWeight: "bold",
                fontSize: "14px",
                textAlign: "center",
                background: "var(--light-grey)",
              }}
            >
              STT
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                fontSize: "14px",
                textAlign: "center",
                background: "var(--light-grey)",
              }}
            >
              Tên sản phẩm
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                fontSize: "14px",
                textAlign: "center",
                background: "var(--light-grey)",
              }}
            >
              Mã sản phẩm (SKU)
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                fontSize: "14px",
                textAlign: "center",
                background: "var(--light-grey)",
              }}
            >
              Số lượng {!prodReturn ? null : "trả"} ({prodReturn ? currTotal : currTotal + `/` + total})
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {prodList?.map((v, index) => {
            return (
              <OrderTableItem
                prodReturn={prodReturn}
                item={v}
                index={index}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const OrderTableItem = ({ item, index, prodReturn }) => {
  return (
    <TableRow>
      <TableCell sx={{ textAlign: "center" }}>{index + 1}</TableCell>
      <TableCell sx={{ textAlign: "center" }}>
        {item?.productModel?.product?.name ?? "-"} ({item?.productModel?.name})
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>{item?.productModel?.sku}</TableCell>
      <TableCell sx={{ textAlign: "center" }}>{!prodReturn ? `${item?.pickedQty ?? 0}/${item?.qty ?? 0}` : `${item?.returnedQty ?? 0}/${item?.qty ?? 0}`}</TableCell>
    </TableRow>
  );
};
